import React, { useContext, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from '@xstate/react';
import { motion } from 'framer-motion';

import { PageHeader } from '@chargify/custom-ui-components';
import { useDeviceInfo } from '@chargify/device-provider';

import { SubscriptionContainer } from '../../containers';
import { GlobalStateContext } from '../../contexts';

import {
  subscriptionsSelectors,
  productCatalogSelectors,
} from '../../machines';

const Subscription = () => {
  const { t } = useTranslation(['subscriptions-manager']);
  const navigate = useNavigate();
  const { device } = useDeviceInfo();
  const isOnMobileDevice = ['tablet', 'mobile'].includes(device);

  const { catalogId, subscriptionId } = useParams();
  const { subscriptionsService, productCatalogService } =
    useContext(GlobalStateContext);

  const productCatalog = useSelector(
    productCatalogService,
    useCallback(
      productCatalogSelectors.getProductCatalogById(Number(catalogId)),
      []
    )
  );

  const { subscription } = useSelector(
    subscriptionsService,
    useCallback(
      subscriptionsSelectors.getSubscriptionById(
        Number(catalogId),
        Number(subscriptionId)
      ),
      []
    )
  );

  const {
    id,
    product: { name },
  } = subscription;

  return (
    <div>
      <PageHeader
        title={productCatalog?.name && `${productCatalog.name}:`}
        subtitle={name}
        size={isOnMobileDevice ? 'small' : 'medium'}
        previousPageLabel={t('back_to_subscriptions_list', {
          ns: 'subscriptions-manager',
        })}
        onBack={() => navigate('/')}
      />
      <motion.div
        style={{ position: 'relative' }}
        initial={{ top: 50, opacity: 0.2 }}
        animate={{ top: 0, opacity: 1 }}
      >
        <SubscriptionContainer
          id={id}
          detailsVisible={true}
          product={subscription.product}
          status={subscription.status}
          components={subscription.components}
          productFamilyId={subscription.productFamilyId}
          currency={subscription.currency}
          layout="all-details"
        />
      </motion.div>
    </div>
  );
};

export default Subscription;
